<template>
    <div class="content fit_main_background">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-10 def-height">
                    <div class="exp">
                        <div class="row">
                            <div class="col-md-1">
                                <img class="rounded-circle" width="50" height="50"
                                    :src="exp.user.avatar ? exp.user.avatar : '/img/default-avatar.png'" alt="avatar">
                            </div>
                            <div class="col-md-11">
                                <div class="row header">
                                    <h5 style="max-width: fit-content;">{{ exp.user.username }}</h5>
                                    <base-dropdown icon="fas fa-ellipsis-h" tag="div" style="max-width: fit-content;">
                                        <a class="dropdown-item danger cursor" @click="itemAction('delete', exp)">Delete</a>
                                    </base-dropdown>
                                </div>
                                <div class="card">
                                    <img class="img-fluid" :src="exp.image" alt="exp image" v-if="exp.image">
                                    <h3>{{ exp.title }}</h3>
                                    <p>{{ exp.content }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="res" v-for="response in exp.responses" :key="response.id" dir="rtl">
                        <div class="row">
                            <div class="col-md-1">
                                <img class="rounded-circle" width="50" height="50"
                                    :src="response.user.avatar ? response.user.avatar : '/img/default-avatar.png'"
                                    alt="avatar">
                            </div>
                            <div class="col-md-11" style="padding-bottom: 50px;">
                                <div class="row header">
                                    <h5>{{ response.user.username }}</h5>
                                    <base-dropdown icon="fas fa-ellipsis-h" tag="div" style="max-width: fit-content;">
                                        <a class="dropdown-item danger cursor" @click="itemAction('delete', response)">Delete</a>
                                    </base-dropdown>
                                </div>
                                <div class="card">
                                    <p>{{ response.content }}</p>
                                </div>
                                <div class="row">
                                    <i class="fas fa-thumbs-up"></i>
                                    <p class="like_counter">{{ response.likes }}</p>
                                    <i class="fas fa-thumbs-down"></i>
                                    <p class="like_counter">{{ response.dislikes }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-11 comment">
                    <div class="card">
                        <div class="row">
                            <div class="col-md-11">

                                <textarea id="comment" rows="4">

                                </textarea>
                            </div>
                            <div class="col-md-1 center">

                                <i class="fas fa-paper-plane" @click="sendComment"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table.vue'
import axios from 'axios';
import { Apis } from '../constants';

export default {
    components: {
        LTable,
        StatsCard
    },
    data() {
        return {
            exp: {
                title: '',
                content: '',
                image: '',
                user: {
                    username: '',
                    avatar: ''
                },
                responses: [
                    {
                        user: {
                            username: '',
                            avatar: ''
                        },
                        content: ''
                    }
                ]
            }
        }
    },
    mounted() {
        this.$loading.show();
        const params = {
            expId: this.$route.params.expId,
            slug: this.$route.params.slug
        }
        axios.get(Apis.show_exp + "/" + params.expId + "/" + params.slug, {
            withCredentials: true
        }).then(response => {
            this.exp = response.data;
        }).catch(error => {
            console.log(error);
        }).finally(() => {
            this.$loading.hide();
        });
    },
    methods: {
        sendComment() {
            const comment = document.getElementById('comment').value;
            if (comment) {
                this.$loading.show();
                let form = new FormData();
                form.append('content', comment);
                form.append('exp_id', this.$route.params.expId);
                axios.post(Apis.add_exp_comment, form, {
                    withCredentials: true
                }).then(response => {
                    this.exp = response.data;
                    this.$router.go(0);
                }).catch(error => {
                    console.log(error);
                }).finally(() => {
                    this.$loading.hide();
                });
            }
        },
        itemAction(action, item){
            console.log(action, item);
        }
    }
}
</script>

<style lang="scss" >
$primary: #b0e0b7;
$secondary: #2f8c40;
$gray: #7d7f84;
$danger: #8e3333;

.danger {
    color: $danger !important;
}

.cursor {
    cursor: pointer;
}

.comment {
    position: sticky;
    bottom: 0;

    .card {
        border-radius: 15px;
        overflow: hidden;
        justify-content: center;

        textarea {
            width: 100%;
            height: 100%;
            border: none;
            direction: rtl;
            padding: 10px;
        }

        .center {
            display: grid;
            place-items: center;

            i {
                align-self: center;
                font-size: 24px;
                color: $secondary;
                cursor: pointer;
            }
        }
    }
}

.fit_main_background {
    background-color: #f4f6f9;
    height: 100%;
    padding: 20px;
}

.header {
    justify-content: space-between;
    align-items: center;
    padding-left: 2%;
    padding-right: 3%;

    h5 {
        margin-top: auto;
        margin-bottom: auto;
    }

    i {
        font-size: 24px;
        color: $gray;
    }
}

.exp {
    .card {
        margin-top: 10px;
        border-radius: 0px 20px 20px 20px;
        direction: rtl;
        border: 3px solid $primary;

        h3 {
            text-align: right;
            margin: 20px;
        }

        p {
            text-align: right;
            margin: 20px;
        }

        img {
            border-radius: 0px 20px 0px 0px;
            // shadow
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.53);
        }

    }
}

.res {

    h5 {
        text-align: right;
        max-width: fit-content;
    }

    i {
        margin: 10px;
        font-size: 20px;
        color: $gray;
        cursor: pointer;
    }

    .like_counter {
        margin-top: auto;
        margin-bottom: auto;
    }

    .card {
        margin-top: 10px;
        border-radius: 20px 0px 20px 20px;
        direction: rtl;
        border: 3px solid $primary;
        margin-bottom: 0px;

        h3 {
            text-align: right;
            margin: 20px;
        }

        p {
            text-align: right;
            margin: 20px;
            white-space: pre-line;
        }

        img {
            border-radius: 0px 20px 0px 0px;
            // shadow
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.53);
        }

    }
}
</style>
